export const topics = [
  { id: 't1', name: '娱乐圈塌房', heat: '980万', tag: '爆', color: 'accent' },
  { id: 't2', name: '顶流恋情曝光', heat: '856万', tag: '热', color: 'accent' },
  { id: 't3', name: '综艺剧本内幕', heat: '743万', tag: '新', color: 'primary' },
  { id: 't4', name: '网红翻车实录', heat: '691万', tag: '热', color: 'accent' },
  { id: 't5', name: '选秀黑幕深扒', heat: '628万', tag: '沸', color: 'accent' },
  { id: 't6', name: '私生饭追踪', heat: '512万', tag: '', color: 'secondary' },
  { id: 't7', name: '品牌代言风波', heat: '487万', tag: '新', color: 'primary' },
  { id: 't8', name: '影视剧换角', heat: '435万', tag: '', color: 'secondary' },
  { id: 't9', name: '直播带货争议', heat: '398万', tag: '', color: 'secondary' },
  { id: 't10', name: '艺人税务问题', heat: '362万', tag: '', color: 'secondary' },
  { id: 't11', name: 'CP营业真假', heat: '319万', tag: '', color: 'secondary' },
];

export const rankings = [
  { rank: 1, title: '某顶流夜会神秘女子，工作室紧急发声明否认', views: '320万', change: 'up', hot: true },
  { rank: 2, title: '知名导演被曝片场霸凌演员，多名工作人员实名爆料', views: '287万', change: 'up', hot: true },
  { rank: 3, title: '选秀节目投票数据造假，节目组深夜道歉', views: '254万', change: 'up', hot: false },
  { rank: 4, title: '某女星被拍到与富商同游，疑似恋情曝光', views: '231万', change: 'down', hot: false },
  { rank: 5, title: '网红主播带货假货被实锤，品牌方集体解约', views: '198万', change: 'up', hot: true },
  { rank: 6, title: '综艺节目剪辑恶意制造矛盾，艺人方发律师函', views: '176万', change: 'new', hot: false },
  { rank: 7, title: '某男团成员被爆私联粉丝，后援会宣布解散', views: '155万', change: 'up', hot: false },
];

export const updates = [
  { id: 'u1', time: '10分钟前', title: '某女星工作室凌晨发声明否认插足他人婚姻，称将通过法律途径维权', category: '声明' },
  { id: 'u2', time: '28分钟前', title: '古装剧片场发生意外，替身演员受伤送医，剧组暂未回应', category: '突发' },
  { id: 'u3', time: '1小时前', title: '知名编剧公开指责某平台拖欠稿费，引发行业热议', category: '争议' },
  { id: 'u4', time: '2小时前', title: '某综艺录制现场观众爆料：评委当场翻脸离席，节目被迫中断', category: '爆料' },
  { id: 'u5', time: '3小时前', title: '品牌方紧急撤下某代言人所有物料，疑似解约在即', category: '商务' },
  { id: 'u6', time: '5小时前', title: '某短视频平台头部网红被封号，官方称违反社区规范', category: '封禁' },
  { id: 'u7', time: '7小时前', title: '乐坛天王新专辑疑似抄袭被扒，网友逐帧对比实锤', category: '深扒' },
];

export const carousels = [
  {
    id: 'c1',
    title: '2024年度塌房明星盘点：从顶流到谷底',
    desc: '盘点今年最令人震惊的明星塌房事件，从顶流爱豆到实力派演员，谁翻车翻得最彻底？深度复盘每一场风波背后的真相与教训。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20entertainment%20news%20studio%20background%20with%20dramatic%20warm%20spotlight%20on%20a%20director%20chair%2C%20atmospheric%20smoke%2C%20luxurious%20red%20and%20gold%20accents%2C%20mysterious%20moody%20lighting%2C%20professional%20photography%20style%2C%20no%20people%2C%20abstract%20entertainment%20industry%20concept&width=800&height=500&seq=carousel-01&orientation=landscape',
    badge: '年度盘点',
  },
  {
    id: 'c2',
    title: '网红圈内幕大起底：光鲜背后的灰色产业链',
    desc: '从MCN机构压榨到数据造假，从剧本炒作到虚假人设，揭开网红经济不为人知的另一面，带你看清屏幕背后的真相。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20studio%20with%20ring%20light%20and%20professional%20camera%20equipment%20on%20a%20minimal%20set%2C%20warm%20dramatic%20lighting%20creating%20long%20shadows%2C%20behind%20the%20scenes%20aesthetic%2C%20mysterious%20atmosphere%2C%20gossip%20and%20rumor%20concept%2C%20cinematic%20mood&width=800&height=500&seq=carousel-02&orientation=landscape',
    badge: '深度调查',
  },
  {
    id: 'c3',
    title: '综艺剧本流出？聊聊真人秀到底有多"真"',
    desc: '从选秀节目到真人秀综艺，所谓的"真实记录"背后到底有多少编剧在操盘？业内人士匿名爆料综艺制作的全流程内幕。',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20backstage%20production%20equipment%2C%20warm%20gold%20and%20amber%20tones%2C%20dramatic%20contrast%20lighting%2C%20showbiz%20entertainment%20industry%20concept%2C%20cinematic%20professional%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
    badge: '独家揭秘',
  },
  {
    id: 'c4',
    title: '艺人合约纠纷全记录：天价违约金背后的博弈',
    desc: '当红艺人为何频频与经纪公司对簿公堂？深入剖析近年最具争议的艺人解约案，解读娱乐圈的资本游戏规则与利益分配。',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20law%20office%20with%20warm%20wooden%20desk%20and%20legal%20documents%2C%20dramatic%20window%20light%20casting%20shadows%2C%20gavel%20and%20contracts%2C%20serious%20business%20atmosphere%2C%20warm%20amber%20and%20brown%20color%20palette%2C%20professional%20interior%20design&width=800&height=500&seq=carousel-04&orientation=landscape',
    badge: '法律解读',
  },
  {
    id: 'c5',
    title: '娱乐圈饭圈文化进化史：从追星到控评大战',
    desc: '饭圈文化的十年变迁：从贴吧到超话，从微博到豆瓣，粉丝组织如何演变成今天的数据机器？深度解读饭圈生态的运作机制。',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20concept%20with%20digital%20screens%20displaying%20vibrant%20content%20grids%2C%20warm%20neon-like%20accents%20on%20dark%20background%2C%20modern%20tech-savvy%20youth%20culture%20atmosphere%2C%20social%20network%20visualization%2C%20abstract%20digital%20art%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    badge: '文化观察',
  },
  {
    id: 'c6',
    title: '娱乐圈潜规则：新人入行的真实生存指南',
    desc: '多位圈内人士匿名分享入行经历：从试镜到签约，从跑龙套到走红，娱乐圈新人需要面对哪些不为人知的挑战和潜规则？',
    image: 'https://readdy.ai/api/search-image?query=Theater%20backstage%20with%20vanity%20mirrors%20and%20warm%20dressing%20room%20lights%2C%20costume%20racks%20in%20background%2C%20dramatic%20shadows%2C%20mysterious%20and%20intimate%20atmosphere%2C%20entertainment%20industry%20behind%20the%20scenes%2C%20cinematic%20lighting%20with%20warm%20gold%20tones&width=800&height=500&seq=carousel-06&orientation=landscape',
    badge: '新人必读',
  },
];

export const features = [
  {
    id: 'f1',
    icon: 'ri-flashlight-line',
    title: '实时追踪热点',
    desc: '24小时不间断监控全网黑料动向，第一时间推送最新吃瓜爆料视频，让你永远比别人先知道发生了什么。',
  },
  {
    id: 'f2',
    icon: 'ri-shield-check-line',
    title: '多方信源交叉验证',
    desc: '每条爆料均经过多重信源核实，拒绝单一来源的片面信息，为你呈现事件全貌而非断章取义。',
  },
  {
    id: 'f3',
    icon: 'ri-film-line',
    title: '高清流畅播放',
    desc: '全站视频支持高清画质在线观看，自适应网络环境优化加载速度，无需下载任何插件即可流畅播放。',
  },
  {
    id: 'f4',
    icon: 'ri-eye-off-line',
    title: '无痕浏览模式',
    desc: '支持隐私保护浏览，不记录观看历史和个人偏好，让你安心吃瓜无后顾之忧，保护你的浏览隐私。',
  },
];

export const mediaItems = [
  {
    id: 'm1',
    title: '独家实拍：某女星深夜密会圈外男友被拍全过程',
    duration: '08:24',
    views: '189万',
    image: 'https://readdy.ai/api/search-image?query=Nighttime%20paparazzi%20photography%20scene%20with%20warm%20street%20lamps%20and%20silhouetted%20figures%2C%20urban%20night%20atmosphere%2C%20cinematic%20mood%2C%20mysterious%20vibe%2C%20blurred%20background%20with%20bokeh%20lights%2C%20entertainment%20gossip%20concept&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 'm2',
    title: '片场直击：某剧组因演员迟到停拍三小时引众怒',
    duration: '05:17',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20crew%20members%20silhouettes%2C%20warm%20industrial%20atmosphere%2C%20behind%20the%20scenes%20movie%20making%2C%20dramatic%20lighting%2C%20empty%20director%20chair%20in%20spotlight&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 'm3',
    title: '直播事故合集：这些翻车名场面你一定没看过',
    duration: '12:36',
    views: '234万',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20multiple%20monitors%20and%20professional%20microphone%2C%20warm%20ambient%20lighting%2C%20digital%20content%20creation%20space%2C%20modern%20tech%20environment%2C%20dramatic%20red%20and%20gold%20accent%20lights%2C%20streaming%20concept&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 'm4',
    title: '深扒：某选秀节目投票系统后台数据异常被曝光',
    duration: '16:42',
    views: '312万',
    image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20glowing%20charts%20and%20graphs%20on%20dark%20screens%2C%20warm%20amber%20data%20visualizations%2C%20investigative%20journalism%20concept%2C%20modern%20tech%20office%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20numbers%20and%20statistics&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export const comments = [
  {
    id: 'co1',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20tones%2C%20minimal%20face%20silhouette%2C%20gradient%20amber%20and%20coral%20colors%2C%20modern%20art%20style%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    nickname: '吃瓜一线猹',
    time: '3分钟前',
    content: '这也太炸裂了吧！本来以为是假的，看了视频才发现居然是真的，我整个人都震惊了，今晚睡不着了。',
    likes: 2836,
  },
  {
    id: 'co2',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20coral%20tones%2C%20minimal%20female%20face%20silhouette%2C%20soft%20gradient%20colors%2C%20modern%20art%20style%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    nickname: '娱乐圈清道夫',
    time: '15分钟前',
    content: '理性分析一波，这件事其实有三个疑点：时间线对不上、当事人前后说法矛盾、还有第三方证人没出来。',
    likes: 1723,
  },
  {
    id: 'co3',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20orange%20tones%2C%20minimal%20face%20silhouette%2C%20gradient%20gold%20colors%2C%20modern%20art%20style%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    nickname: '瓜田守望者',
    time: '28分钟前',
    content: '坐等后续反转！按照娱乐圈的规律，这种一开始看起来板上钉钉的事最后肯定会有大反转，我押一个洗白。',
    likes: 1245,
  },
  {
    id: 'co4',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20brown%20tones%2C%20minimal%20male%20face%20silhouette%2C%20earth%20tone%20gradient%2C%20modern%20art%20style%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    nickname: '爆料的都是我',
    time: '42分钟前',
    content: '作为业内人我只能说，真相比你们看到的还要复杂十倍，有些料不是不想爆，是爆了号就没了。',
    likes: 3567,
  },
  {
    id: 'co5',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20peach%20tones%2C%20minimal%20female%20face%20silhouette%2C%20soft%20pink%20and%20gold%20gradient%2C%20modern%20art%20style%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    nickname: '热心市民李女士',
    time: '1小时前',
    content: '你们都在关注主角，难道没人注意到那个一闪而过的路人吗？我截图放大看了十遍，那绝对是圈内某大佬。',
    likes: 4892,
  },
];

export const cards = [
  {
    id: 'cd1',
    title: '某综艺导师被曝私下收取学员巨额"拜师费"',
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20interior%20with%20warm%20lighting%20and%20recording%20equipment%2C%20microphone%20stand%20in%20spotlight%2C%20dramatic%20shadows%2C%20music%20industry%20concept%2C%20professional%20photography%20style%2C%20mysterious%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '综艺内幕',
    time: '2小时前',
    views: '89万',
  },
  {
    id: 'cd2',
    title: '品牌方连夜开会：某代言人负面新闻持续发酵',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20warm%20wooden%20table%20and%20luxurious%20chairs%2C%20night%20city%20view%20through%20window%2C%20dramatic%20moody%20lighting%2C%20business%20crisis%20meeting%20concept%2C%20professional%20interior&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '品牌风波',
    time: '3小时前',
    views: '76万',
  },
  {
    id: 'cd3',
    title: '深扒某网红年入过亿的背后：数据造假实锤',
    image: 'https://readdy.ai/api/search-image?query=Digital%20analytics%20dashboard%20with%20rising%20charts%20and%20social%20media%20metrics%2C%20warm%20neon%20accent%20lighting%2C%20data%20manipulation%20concept%2C%20modern%20tech%20aesthetic%2C%20dramatic%20contrast&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '深挖爆料',
    time: '5小时前',
    views: '134万',
  },
  {
    id: 'cd4',
    title: '某大型活动后台吵架录音曝光：大咖现场翻脸',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20dressing%20room%20doors%20and%20warm%20vanity%20lights%2C%20dramatic%20shadows%20and%20tension%20atmosphere%2C%20event%20venue%20behind%20the%20scenes%2C%20entertainment%20industry%20drama%20concept&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '现场爆料',
    time: '8小时前',
    views: '201万',
  },
  {
    id: 'cd5',
    title: '粉丝应援金额被挪用？后援会财务明细疑点重重',
    image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20and%20receipts%20scattered%20on%20a%20warm%20wooden%20desk%2C%20calculator%20and%20bank%20statements%2C%20investigative%20atmosphere%2C%20dramatic%20desk%20lamp%20lighting%2C%20money%20scandal%20concept&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '财务疑云',
    time: '12小时前',
    views: '167万',
  },
];

export const indexItems = [
  { id: 'i1', name: '明星恋情', count: '2.3万', icon: 'ri-heart-line' },
  { id: 'i2', name: '综艺节目', count: '1.8万', icon: 'ri-tv-line' },
  { id: 'i3', name: '网红八卦', count: '1.6万', icon: 'ri-live-line' },
  { id: 'i4', name: '影视圈内幕', count: '1.4万', icon: 'ri-film-line' },
  { id: 'i5', name: '品牌代言', count: '1.2万', icon: 'ri-vip-crown-line' },
  { id: 'i6', name: '选秀黑幕', count: '1.1万', icon: 'ri-mic-line' },
  { id: 'i7', name: '饭圈文化', count: '9.8千', icon: 'ri-group-line' },
];

export const appInfo = {
  title: '黑料视频 App — 吃瓜更方便',
  desc: '下载黑料视频 App，随时随地追最新爆料。推送比网页快3秒，支持离线缓存和弹幕互动，还有专属爆料投稿通道等你来。',
  features: ['全网爆料秒推送', '高清视频流畅播放', '匿名投稿安全无忧', '弹幕吃瓜更欢乐'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20warm%20dark%20theme%2C%20video%20thumbnails%20grid%2C%20modern%20mobile%20UI%20design%2C%20floating%20phone%20on%20gradient%20background%2C%20clean%20minimal%20style&width=400&height=700&seq=app-phone-01&orientation=portrait',
};

export const contactInfo = {
  title: '有料要爆？联系我们',
  desc: '如果你掌握第一手黑料线索、独家视频素材或内幕消息，欢迎通过以下方式联系我们。所有爆料人均受严格匿名保护，你的身份信息绝不会泄露。',
  email: 'tips@heiliao.video',
  wechat: 'heiliao_tips',
  tips: '爆料内容一经核实并采用，将根据内容质量和热度给予丰厚奖励。',
};

export const faqs = [
  {
    id: 'faq1',
    q: '黑料视频网站的内容来源是什么？',
    a: '我们的内容来源于全网公开信息聚合、用户匿名投稿以及特约爆料人提供的一手素材。所有内容发布前均经过编辑团队初步核实，标注信息来源与可信度等级，帮助用户判断内容可靠性。',
  },
  {
    id: 'faq2',
    q: '黑料视频免费观看需要注册吗？',
    a: '不需要。黑料视频网站所有内容均免费开放，无需注册即可在线观看全部视频和图文内容。我们坚持零门槛访问，让每一位用户都能即时获取最新的吃瓜爆料信息。',
  },
  {
    id: 'faq3',
    q: '如何投稿爆料？投稿后会得到什么保护？',
    a: '你可以通过页面的联系方式发送邮件或添加微信进行投稿。我们承诺对所有爆料人信息进行最严格的匿名保护——不记录IP、不要求实名、不留存通讯记录。被采用的爆料还将获得丰厚奖励。',
  },
  {
    id: 'faq4',
    q: '视频加载慢或无法播放怎么办？',
    a: '如遇到播放问题，建议先检查网络连接或尝试切换Wi-Fi/移动网络。我们的服务器已针对国内主流网络环境进行优化，支持自适应码率。如问题持续，可尝试清除浏览器缓存或更换浏览器访问。',
  },
  {
    id: 'faq5',
    q: '黑料视频网站的内容多久更新一次？',
    a: '我们保持7×24小时不间断更新，编辑团队全天候追踪全网热点。平均每30分钟即有新内容上线，重大突发事件发生后15分钟内即可完成内容发布，确保你获取信息的速度始终快人一步。',
  },
];

export const aboutInfo = {
  title: '关于黑料视频',
  paragraphs: [
    '黑料视频是国内领先的吃瓜爆料视频聚合平台，致力于为用户提供最新、最全、最真实的娱乐圈、网红圈及社会热点爆料内容。我们以"让真相不再沉默"为使命，通过技术手段聚合全网优质爆料资源，打造一站式的吃瓜体验。',
    '自上线以来，黑料视频已累计收录超过50万条爆料视频内容，覆盖明星、网红、综艺、影视、品牌等多个垂直领域。我们坚持"快、全、真"的内容标准——推送速度行业领先、内容覆盖全面无死角、信息来源多方交叉验证。',
    '我们的编辑团队由资深娱乐记者、前MCN运营人员及数据挖掘工程师组成，确保每一条内容的专业性和可信度。同时，我们建立了严格的用户隐私保护机制和内容审核流程，在追求速度的同时不牺牲品质与底线。',
  ],
  stats: [
    { value: '50万+', label: '累计视频' },
    { value: '3000万+', label: '月活用户' },
    { value: '15分钟', label: '热点响应' },
    { value: '99.9%', label: '服务可用率' },
  ],
};

export const heroData = {
  tag: '🔥 今日最热',
  slogan: '不放过每一个瓜，不错过每一段料',
  intro: '黑料视频聚合全网最新最全吃瓜爆料视频资源，覆盖明星塌房、网红翻车、综艺内幕、选秀黑幕等热门领域。每日更新超过500条独家爆料与深度深扒内容，高清流畅在线观看，无需下载即刻访问。无论是顶流恋情、品牌代言风波，还是饭圈数据大战、影视圈潜规则，你想知道的料，这里都有。',
  stats: [
    { label: '今日更新', value: '487条' },
    { label: '在线观看', value: '126万人' },
    { label: '独家爆料', value: '32条' },
  ],
  primaryCta: { text: '立即吃瓜', href: '#topics' },
  secondaryCta: { text: '我有猛料', href: '#contact' },
};

export const footerData = {
  description: '黑料视频 — 全网最新最全吃瓜爆料视频聚合平台。聚合黑料视频网、黑料视频网站等高清免费入口，即时访问最新吃瓜爆料视频，无需下载直接在线看。覆盖明星、网红、综艺、影视、品牌等多个领域的热点爆料内容。',
  navGroups: [
    {
      title: '热门板块',
      links: [
        { label: '话题标签', href: '#topics' },
        { label: '热度榜单', href: '#ranking' },
        { label: '吃瓜快讯', href: '#updates' },
        { label: '深度专题', href: '#carousel' },
        { label: '主题索引', href: '#index' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问答', href: '#faq' },
        { label: '联系我们', href: '#contact' },
        { label: '移动端入口', href: '#app' },
        { label: '读者评论', href: '#comments' },
      ],
    },
  ],
};